import React, { useContext } from "react";
import {
  Button,
  Caption,
  Card,
  ColorPicker,
  Collapsible,
  Layout,
  Stack,
  TextField,
  TextContainer,
  TextStyle,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const ButtonText = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { BUTTON_TEXT, DEFAULT_HEADER_COLOR, HEX, COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.buttonTextColor.title")}
        description={cms("section.buttonTextColor.description")}
      >
        <Card
          title={[
            cms("section.buttonTextColor.title"),
            updatedAt && (
              <TextStyle variation="subdued">
                <Caption>{`${baseHelper.lastUpdateDate(updatedAt)}`}</Caption>
              </TextStyle>
            ),
          ]}
          // actions={[
          //   { content: "Learn more", onAction: () => learnMore(cms("section.buttonTextColor.title"), "TODO: ") },
          // ]}
        >
          <Card.Section>
            <TextContainer>{cms("section.buttonTextColor.subDescription")}</TextContainer>
            <br />
            <Stack>
              <Stack.Item fill>
                <TextField
                  label={cms("section.buttonTextColor.label.hexCode")}
                  value={hex.buttonTextHex}
                  onChange={(value) => handleChange(BUTTON_TEXT, value, HEX)}
                  labelAction={
                    hex.buttonTextHex !== DEFAULT_HEADER_COLOR && {
                      content: cms("label.reset"),
                      onClick: () => resetDefault(BUTTON_TEXT, DEFAULT_HEADER_COLOR, HEX),
                    }
                  }
                  error={errorMessage && errorMessage.buttonText}
                />
                <br />
                <Button primary>{cms("section.buttonTextColor.label.sampleText")}</Button>
              </Stack.Item>
              <Stack.Item>
                <ColorPicker onChange={(value) => handleChange(BUTTON_TEXT, value, COLOR)} color={color.buttonText} />
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(ButtonText), {
  feature: constant.STANDARD_BRANDING,
});
